module.exports = __webpack_public_path__ + "img/refresh@2x.0207114b.png";